module.exports = __webpack_public_path__ + "static/media/480.9c7bf89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-saw/light/480.png
// module id = 2402
// module chunks = 2